import { Grid, Typography, Divider, Link, Box } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'src/shared/functions/formatDate';
import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/services/store';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { InvoicePayment } from '../models/invoicePayment';
import { Invoice } from '../models/invoice';

type InvoiceMissionDetailsProps = {
  balance: number;
  invoice: Invoice;
};

const InvoiceMissionDetails = (props: InvoiceMissionDetailsProps) => {
  const { balance, invoice } = props;
  const { mission, payments } = invoice;

  const { t } = useTranslation(['invoice']);
  const user = useSelector((state: RootState) => state.oidc.user);

  const FSPayLink = `${process.env.REACT_APP_FS_PAY_URL}/${invoice.invoice_id}/${invoice.invoiceGuid}/${user?.profile.custname}`;

  return (
    <ContentSection header={t('invoice:payment.payments')}>
      {mission ? (
        <>
          <Grid container item xs={12}>
            <Grid xs={12} item>
              <Typography sx={{ fontWeight: 600, fontSize: 16 }} variant='h6'>
                {t('invoice:payment.payee')}:
              </Typography>
            </Grid>
            <Grid xs={12} item>
              <Typography sx={{ wordBreak: 'break-word' }}>{mission.senderName}</Typography>
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            <Grid xs={12} item>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mt: 2 }} variant='h6'>
                {t('invoice:payment.paymentAccount')}:
              </Typography>
            </Grid>
            <Grid xs={12} item>
              <Typography>{mission.accountNr}</Typography>
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            <Grid xs={12} item>
              <Typography sx={{ fontWeight: 600, fontSize: 16, mt: 2 }} variant='h6'>
                {t('invoice:payment.balance')}:
              </Typography>
            </Grid>
            <Grid xs={12} item>
              <Typography>
                <AmountWithCurrency amount={balance} />
              </Typography>
            </Grid>
          </Grid>
          {invoice.invoiceGuid && user && (
            <Grid item xs={12} display='flex' alignItems='center' sx={{ mt: 1 }}>
              <OpenInNewOutlined />
              <Link ml={1.5} href={FSPayLink} target='_blank' rel='noopener noreferrer'>
                {t('invoice:payment.paymentViaFs')} FS Pay
              </Link>
            </Grid>
          )}
          {payments && payments?.length > 0 && (
            <Grid item xs={12}>
              <Divider />
            </Grid>
          )}
          <Grid item xs={12} flexDirection='column'>
            {payments &&
              payments.map((payment: InvoicePayment) => {
                return (
                  <Box key={payment.invoicePayment_id}>
                    <Typography sx={{ fontWeight: 600, fontSize: 16, mt: 2 }} variant='h6'>
                      {t('invoice:payment.paymentRegistratedThrough')} {payment.source}, <AmountWithCurrency amount={payment.amount} />
                    </Typography>
                    <Typography sx={{ lineHeight: 1 }} color='GrayText' variant='subtitle1'>
                      {formatDate(payment.date)}
                    </Typography>
                  </Box>
                );
              })}
          </Grid>
        </>
      ) : (
        <Typography>{t('invoice:payment.noPaymentInfo')}</Typography>
      )}
    </ContentSection>
  );
};

export default InvoiceMissionDetails;
